import React, { useEffect, useRef } from 'react';
import './DigitInput.css';

export default function DigitInput({ value, onChange, focused, onKeyDown, isSuccess, isError }) {
  const inputRef = useRef();
  useEffect(() => {
    if (focused && inputRef.current) {
      inputRef.current.focus();
    }
  }, [focused]);

  return (
    <input
      ref={inputRef}
      className={`digit-pureinput${focused ? " focused" : ""}${isSuccess ? " success" : ""}${isError ? " error" : ""}`}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      minLength={1}
      maxLength={1}
      value={value || ''}
      onChange={e => {
        const v = e.target.value;
        if (/^\d$/.test(v)) onChange(v);
        else if (v === '') onChange('');
      }}
      onClick={() => { if (inputRef.current) inputRef.current.select(); }}
      onKeyDown={onKeyDown}
      autoComplete="one-time-code"
      max={9}
      style={{ textAlign: 'center' }}
    />
  );
}
